//namespace Pacem.Mathematics.DataAnalysis {
const SQRT_PI = Math.sqrt(Math.PI);
/**
 * Complementary Error Function as seen on Numerical Recipes in C (p.221).
 * @param x Input
 */
function erfc(x) {
    const z = Math.abs(x);
    const t = 1.0 / (1.0 + 0.5 * z);
    const ans = t * Math.exp(-z * z - 1.26551223 + t * (1.00002368 + t * (0.37409196 + t * (0.09678418 +
        t * (-0.18628806 + t * (0.27886807 + t * (-1.13520398 + t * (1.48851587 +
            t * (-0.82215223 + t * 0.17087277)))))))));
    return x >= 0.0 ? ans : 2.0 - ans;
}
/**
 * Error Function.
 * @param x
 */
function erf(x) {
    return 1 - erfc(x);
}
export class Gaussian {
    constructor(mean, stdev) {
        this.mean = mean;
        this.stdev = Math.abs(stdev);
        this.variance = Math.pow(stdev, 2);
    }
    static get normal() {
        return _normal;
    }
    /**
     * Un-normalized probability density function.
     * Can be useful as a weight function without requiring the integral w(x)dx to be 1.
     * @param x Input value
     */
    weight(x) {
        // e^(.5 *(-Z^2))
        return Math.exp(-0.5 * Math.pow(this._z(x), 2));
    }
    /**
     * Probability density function (PDF).
     * @param x Input value
     */
    probabilityDensity(x) {
        // 1/(σ √2π) * e^(.5 *(-Z^2))
        const inv_coeff = this.stdev * Math.SQRT2 * SQRT_PI, exp_part = this.weight(x);
        return exp_part / inv_coeff;
    }
    _z(x) {
        // Z = (x - μ)/σ
        return (x - this.mean) / this.stdev;
    }
    /**
     * Returns the area under the PDF from -∞ to x
     * @param x Input value
     */
    probability(x) {
        return 0.5 * erfc(-this._z(x) / Math.SQRT2);
    }
}
const _normal = new Gaussian(0, 1);
//}
